module.exports = __webpack_public_path__ + "static/media/ser_no_tip.101c3a61.png";